import * as React from 'react';
import styles from './ChartLoader.module.css';
import { Spinner } from '@ixicare/ui';

const ChartLoader = () => (
  <div className={styles.ChartLoader}>
    <Spinner label="Loading data..." />
  </div>
);
export default ChartLoader;
